module.exports = __webpack_public_path__ + "static/media/SF-UI-Text-Bold.ef7a61ae.woff";